import { render, staticRenderFns } from "./ViewImagesDialog.vue?vue&type=template&id=366d06ae&scoped=true&lang=pug&"
import script from "./ViewImagesDialog.vue?vue&type=script&lang=js&"
export * from "./ViewImagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ViewImagesDialog.vue?vue&type=style&index=0&id=366d06ae&lang=scss&scoped=true&"
import style1 from "./ViewImagesDialog.vue?vue&type=style&index=1&id=366d06ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d06ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VImg,VProgressCircular,VSpacer,VWindow,VWindowItem})
